
import { Button } from "@/components/ui/button";
import { MessageSquare } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="py-4 px-6 md:px-12 flex items-center justify-between bg-white shadow-sm">
      <div className="flex items-center">
        <Link to="/" className="text-xl font-bold bg-gradient-to-r from-seo-primary to-seo-secondary bg-clip-text text-transparent">
          LocalUp
        </Link>
      </div>
      
      <div className={`${isMenuOpen ? 'flex' : 'hidden'} md:flex flex-col md:flex-row absolute md:relative top-16 md:top-auto left-0 right-0 bg-white md:bg-transparent p-4 md:p-0 shadow-md md:shadow-none z-50 md:z-auto md:space-x-8 md:items-center`}>
        <Link to="/servicos" className="text-gray-700 hover:text-seo-primary transition-colors py-2 md:py-0">
          Serviços
        </Link>
        <Link to="/sobre" className="text-gray-700 hover:text-seo-primary transition-colors py-2 md:py-0">
          Sobre Nós
        </Link>
        <Link to="/cidades" className="text-gray-700 hover:text-seo-primary transition-colors py-2 md:py-0">
          Cidades
        </Link>
        <Link to="/contato" className="text-gray-700 hover:text-seo-primary transition-colors py-2 md:py-0">
          Contato
        </Link>
        <Button 
          className="bg-green-500 hover:bg-green-600 flex items-center gap-2 mt-2 md:mt-0"
          onClick={() => window.open('https://wa.me/5555115197440?text=Ol%C3%A1%2C%20quero%20uma%20analise%20da%20LocalUP.', '_blank')}
        >
          <MessageSquare className="w-4 h-4" /> WhatsApp
        </Button>
      </div>
      
      <div className="md:hidden">
        <Button variant="ghost" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="4" x2="20" y1="12" y2="12"/><line x1="4" x2="20" y1="6" y2="6"/><line x1="4" x2="20" y1="18" y2="18"/></svg>
        </Button>
      </div>
    </nav>
  );
};

export default Navbar;
